import React, { Component } from "react";
import { connect } from "react-redux";
import { getARPU, setofUpdatedashboardAvtal } from "actions";
import { isEmpty, isUndefined, isNull } from "lodash";
import BackGroupChart from "./BackGroupChart";
import { Grid } from "@material-ui/core";
import { sv } from "date-fns/locale";
import { format } from "date-fns";
import moment from "moment";
import { ArrowUpward, ArrowDownward } from "@material-ui/icons";
import { NumberFormat } from "components/NotyNumberFormat";
import Skeleton from "@material-ui/lab/Skeleton";
import IntlMessages from "util/IntlMessages";
import BoxGroup from "../BoxGroup";

function mapStateToProps({ auth, DashBoard, accountsData, ArtikelReg }) {
  const { authUser } = auth;
  const { updatedashboardAvtal, Flags } = accountsData;
  const { ARPUValue, DashboardAnpassadFilterOption } = DashBoard;
  const { ArtikelTagsList } = ArtikelReg;
  return {
    authUser,
    ARPUValue,
    DashboardAnpassadFilterOption,
    updatedashboardAvtal,
    ArtikelTagsList,
		Flags
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getARPU: (
      Afid,
      userid,
      DashboardAnpassadFilterOption,
      mainValue,
      DashId,
      callback
    ) =>
      dispatch(
        getARPU(
          Afid,
          userid,
          DashboardAnpassadFilterOption,
          mainValue,
          DashId,
          callback
        )
      ),
    setofUpdatedashboardAvtal: () => dispatch(setofUpdatedashboardAvtal()),
    dispatch,
  };
}

class TopList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ARPUValue: 0,
      DashboardAnpassadFilterOption: [],
      done: false,
      cardHeight: 0,
    };
    this.cardRef = React.createRef();
    this.initiateInterval = this.initiateInterval.bind(this);
    this.formatNumber = this.formatNumber.bind(this);
  }

  intervalID = null;
  componentDidMount = () => {
    const Afid = this.props.authUser.user_Afid;
    const userid = this.props.authUser.user_id;
    this.props
      .getARPU(
        Afid,
        userid,
        this.props.DashboardAnpassadFilterOption,
        this.props.mainValue,
        this.props.DashId,
        (data) => {
          this.setState({
            ...this.state,
            ARPUValue: data.SummaBillingAvtal / this.props.userCount,
          });
        }
      )
      .then(() => {
        this.initiateInterval();
        this.setState({ done: true });
      });
  };
  initiateInterval() {
    clearInterval(this.intervalID);
    this.intervalID = null;
    this.intervalID = setInterval(() => {
      if (this.state.done === true) {
        this.setState({ done: false });
        const Afid = this.props.authUser.user_Afid;
        const userid = this.props.authUser.user_id;
        this.props
          .getARPU(
            Afid,
            userid,
            this.props.DashboardAnpassadFilterOption,
            this.props.mainValue,
            this.props.DashId,
            (data) => {
              this.setState({
                ...this.state,
                ARPUValue: data.SummaBillingAvtal / this.props.userCount,
              });
            }
          )
          .then(() => {
            this.initiateInterval();
            this.setState({ done: true });
          });
      }
    }, 180000);
  }
  componentDidUpdate = () => {
    const userid = this.props.authUser.user_id;
    const Afid = this.props.authUser.user_Afid;
    if (parseInt(this.props.updatedashboardAvtal) === 1) {
      this.props
        .getARPU(
          Afid,
          userid,
          this.props.DashboardAnpassadFilterOption,
          this.props.mainValue,
          this.props.DashId,
          (data) => {
            this.setState({
              ...this.state,
              ARPUValue: data.SummaBillingAvtal / this.props.userCount,
            });
          }
        ) /**/
        .then(() => {
          this.initiateInterval();
          this.setState({ done: true });
        });
      this.props.setofUpdatedashboardAvtal();
    }
    if (
      this.props.DashboardAnpassadFilterOption !==
      this.state.DashboardAnpassadFilterOption
    ) {
      this.setState({ done: false });
      this.props
        .getARPU(
          Afid,
          userid,
          this.props.DashboardAnpassadFilterOption,
          this.props.mainValue,
          this.props.DashId,
          (data) => {
            this.setState({
              ...this.state,
              ARPUValue: data.SummaBillingAvtal / this.props.userCount,
            });
          }
        ) /**/
        .then(() => {
          this.initiateInterval();
          this.setState({ done: true });
        });
      this.setState({
        DashboardAnpassadFilterOption: this.props.DashboardAnpassadFilterOption,
      });
    }
  };
  componentWillUnmount() {
    clearInterval(this.intervalID);
    this.intervalID = null;
  }
  formatNumber=(number)=>{
		let Nubmer =  NumberFormat(number, this.props.Flags?.DashboardRoundoff === 0 ? 'standard' : 'compact','auto', 0)
		let suffix = Nubmer.match(/[a-zA-Z]+/g)
		let num = Nubmer.replace(suffix, '').trim()
		let fontSize = 100

		if(String(num).length > 5) fontSize = 60
		// if(String(num).length > 7) fontSize = 40

		return <div>
					<span style={{ fontSize: this.props.isFrom === 1 ? 55 : fontSize }}>{num}</span>
					<span style={{ fontSize: '2rem', marginLeft: 5 }}>{this.formatNumberT(number)}</span> 
		</div>
	}
	formatNumberT=(number)=>{
			try{
					let Nubmer =  NumberFormat(number, this.props.Flags?.DashboardRoundoff === 0 ? 'standard' : 'compact','auto', 0)
					let num = Nubmer.match(/[a-zA-Z]+/g)
					return num
			}
			catch(error){
					return ''
			}
	}		
  render() {
    return (
      <>
        <div
          style={{
            backgroundColor: "transparent",
            position: "relative",
            paddingTop:
              (!isNull(this.cardRef.current)
                ? this.cardRef.current.getBoundingClientRect().height
                : 0) -
              (!isNull(this.cardRef.current)
                ? this.cardRef.current.getBoundingClientRect().height
                : 0) /
                1.3,
          }}
        >
          <BackGroupChart
						BackGroudColor={this.props.BackGroudColor}
            height={
              (!isNull(this.cardRef.current)
                ? this.cardRef.current.getBoundingClientRect().height
                : 0) / 1.3
            }
          />
        </div>

        <div
          className="jr-fillchart-content"
          style={{ zIndex: 0, display: "flex", flexDirection: "column" }}
          ref={this.cardRef}
        >
          <div className="text-center text-white">
            <h2
              style={{
                paddingTop: this.props.isFrom === 1 ? "0" : "6px",
                margin: "0",
 								color: isUndefined(this.props.FontColor)?'#fff':this.props.FontColor,
                fontWeight: "500",
                fontSize: this.props.isFrom === 1 ? "20px" : "24px",
              }}
            >
              <IntlMessages id="ARPU" />
              {this.props.getMainValueText(this.props.mainValue)}
              {isEmpty(this.props.ArtikelTagsList) ? (
                ""
              ) : isEmpty(this.props.tagsJSON) ? (
                ""
              ) : (
                <BoxGroup
                  items={JSON.parse(this.props.tagsJSON)}
                  ArtikelTagsList={this.props.ArtikelTagsList}
                />
              )}
            </h2>
            <p
              style={{
                textTransform: "capitalize",
 								color: isUndefined(this.props.FontColor)?'#fff':this.props.FontColor,
                fontSize: this.props.isFrom === 1 ? 14 : "18px",
              }}
            >
              {isEmpty(
                this.props.DashboardAnpassadFilterOption.filter(
                  (item) => item.Meta === "DatumFrom" || item.Meta === "DatumTo"
                )
              ) ? (
                ``
              ) : (
                <>
                  {`
                    ${
                      isEmpty(
                        this.props.DashboardAnpassadFilterOption.filter(
                          (item) => item.Meta === "DatumFrom"
                        )
                      )
                        ? moment(new Date()).format("YYYY-MM-DD")
                        : moment(
                            this.props.DashboardAnpassadFilterOption.filter(
                              (item) => item.Meta === "DatumFrom"
                            )[0].Value
                          ).format("YYYY-MM-DD")
                    }
                    -
                    ${
                      isEmpty(
                        this.props.DashboardAnpassadFilterOption.filter(
                          (item) => item.Meta === "DatumTo"
                        )
                      )
                        ? moment(new Date()).format("YYYY-MM-DD")
                        : moment(
                            this.props.DashboardAnpassadFilterOption.filter(
                              (item) => item.Meta === "DatumTo"
                            )[0].Value
                          ).format("YYYY-MM-DD")
                    }
                    `}
                </>
              )}
            </p>
          </div>
          <div
            style={{ flexGrow: 1, display: "flex", flexDirection: "column" }}
          >
            <div
              className="d-flex align-items-center justify-content-center"
              style={{ flexGrow: 1 }}
            >
              {this.state.done === false ? (
                <Skeleton
                  variant="rectangular"
                  height={100}
                  width={"100%"}
                  style={{
                    margin: "3px auto",
                    backgroundColor: "rgba(38, 9, 72, 0.19)",
                  }}
                />
              ) : (
                <span style={{ color: isUndefined(this.props.FontColor)?'#fff':this.props.FontColor }}>
                  {this.formatNumber(this.state.ARPUValue)}{" "}
                </span>
              )}
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(TopList);
